import React from 'react'
import PropTypes from 'prop-types'
import {
    Typography,
    Button,
} from '@mui/material'

import useStyle from 'shared/hooks/useStyle'
import getGlobalAssetUrl from 'shared/utils/getGlobalAssetUrl'
import styles from './TwoColumnErrorPage.style'

const propTypes = {
    iconPath: PropTypes.string.isRequired,
    iconAlt: PropTypes.string.isRequired,
    buttonLabel: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    buttonDataTestId: PropTypes.string.isRequired,
    messageTop: PropTypes.string.isRequired,
    messageBottom: PropTypes.string,
    middleTexts: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string,
    })),
}

const middleTextsDefault = []

const TwoColumnErrorPage = ({
    iconPath,
    iconAlt,
    buttonLabel,
    onButtonClick,
    buttonDataTestId,
    messageTop,
    messageBottom,
    middleTexts = middleTextsDefault,
}) => {
    const classes = useStyle(styles)

    return (
        <div css={classes.main}>
            <div>
                <img
                    css={classes.icon}
                    src={getGlobalAssetUrl(iconPath)}
                    alt={iconAlt}
                />
            </div>
            <div css={classes.info}>
                <Typography
                    variant="h3"
                    css={classes.text}
                >
                    {messageTop}
                </Typography>
                { middleTexts.length > 0 && (
                    <div css={classes.context}>
                        {middleTexts.map(({
                            label, value,
                        }) => {
                            return (
                                <Typography
                                    variant="h3"
                                    css={classes.text}
                                    key={label}
                                >
                                    {label}
                                    <span css={classes.tempValue}>{value}</span>
                                </Typography>
                            )
                        })}
                    </div>
                )}
                {messageBottom && (
                    <Typography
                        variant="h3"
                        css={classes.text}
                    >
                        {messageBottom}
                    </Typography>
                )}
                <div css={classes.actions}>
                    <Button
                        data-testid={buttonDataTestId}
                        css={classes.button}
                        onClick={onButtonClick}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

TwoColumnErrorPage.propTypes = propTypes

export default TwoColumnErrorPage
